/** Attachments element type */
export const ATTACHMENTS = 'attachments';
